import { takeLatest, call, select } from 'redux-saga/effects';
import { fetchFreshDeviations } from './actionCreators';
import { isApiError, request } from '../../../xhr';
import { getDeviationType, getPrimaryTier, isDeviationAuthor } from '../../../DeviationViews/_helpers';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import { getCurrentUser } from '../../../publicSession/selectors';
import { DeviationTypes } from '../../../types/deviation';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        const deviations = require('@wix/da-sample-data').deviationsByType.image;
        return {
            deviations: deviations.slice(0, 24)
        };
    }
}
function* fetchDeviations(deviations) {
    const commissionIds = [];
    const deviationIds = deviations.slice(0, 24).map((d)=>{
        if (getDeviationType(d) === DeviationTypes.COMMISSION) {
            commissionIds.push(d.deviationId);
            return undefined;
        }
        return d.deviationId;
    }).filter((i)=>i !== undefined);
    let devResult;
    let commResult;
    if (deviationIds.length > 0) {
        devResult = yield call(request, {
            method: 'get',
            url: `/deviation/multifetch`,
            params: {
                deviationids: deviationIds
            }
        }, fakeResponse);
        if (isApiError(devResult)) {
            return devResult;
        }
    }
    if (commissionIds.length > 0) {
        commResult = yield call(request, {
            method: 'get',
            url: `/commission/multifetch`,
            params: {
                commissionids: commissionIds
            }
        }, fakeResponse);
        if (isApiError(commResult)) {
            return commResult;
        }
    }
    // Merge results
    if ((devResult === null || devResult === void 0 ? void 0 : devResult.deviations.length) > 0 && (commResult === null || commResult === void 0 ? void 0 : commResult.commissions.length) > 0) {
        const merged = [
            ...devResult.deviations,
            ...commResult.commissions
        ];
        return deviations.map((d)=>{
            const fresh = merged.find((i)=>i.deviationId === d.deviationId && i.typeId === d.typeId);
            return fresh;
        });
    }
    // Only devs
    if ((devResult === null || devResult === void 0 ? void 0 : devResult.deviations.length) > 0 && (commResult === null || commResult === void 0 ? void 0 : commResult.commissions.length) === 0) {
        return devResult.deviations;
    }
    // Only commissions
    if ((devResult === null || devResult === void 0 ? void 0 : devResult.deviations.length) === 0 && (commResult === null || commResult === void 0 ? void 0 : commResult.commissions.length) > 0) {
        return commResult.commissions;
    }
}
export function* doFetchFresh(action) {
    const { deviations , setEntityData  } = action.payload;
    const currentUser = yield select(getCurrentUser);
    const result = yield call(fetchDeviations, deviations);
    if (result && !isApiError(result)) {
        const freshDeviations = result.map((deviation)=>{
            const isInTier = getPrimaryTier(deviation);
            const isOwner = isDeviationAuthor(deviation, currentUser);
            const { isPremium  } = normalizePremiumFolderData(deviation.premiumFolderData);
            const isForbidden = isPremium || isInTier && !isOwner;
            if (!isForbidden) {
                return deviation;
            }
            return undefined;
        }).filter((i)=>i !== undefined);
        if (freshDeviations.length > 0) {
            return setEntityData(freshDeviations);
        }
    }
    setEntityData(undefined);
}
export default function* saga() {
    yield takeLatest(fetchFreshDeviations, doFetchFresh);
}
